import moment from 'moment';
import { useContext } from 'react';

import { AuthContext } from '../../providers/auth-context';
import { ApiBasket } from '../../api/basketService';
import { Room } from '../../shared/types/room';
import { Building } from '../../shared/types/building';
import { UserChoices } from '../../shared/types/user-choices';
import { InstalmentType } from '../../shared/enum/InstalmentType';

export const useTrackPurchaseEvent = () => {
    const userState = useContext(AuthContext);

    return (basket: ApiBasket, room: Room, building: Building, userChoices: UserChoices) => {
        if (!userState.session) {
            return;
        }

        const category = [
            room.unit_type,
            basket.products[0].term,
            room.academic_year,
            basket.user?.university,
            basket.user?.nationality,
        ];

        let numberOfInstalments: number | string;

        switch (basket.products[0].instalment_type) {
            case InstalmentType.ANNUAL:
                numberOfInstalments = 1;
                break;
            case InstalmentType.INSTALMENTS_2:
                numberOfInstalments = 2;
                break;
            case InstalmentType.INSTALMENTS_3:
                numberOfInstalments = 3;
                break;
            case InstalmentType.INSTALMENTS_4:
                numberOfInstalments = 4;
                break;
            case InstalmentType.INSTALMENTS_10:
                numberOfInstalments = 10;
                break;
            case InstalmentType.INSTALMENTS_12:
                numberOfInstalments = 12;
                break;
            case InstalmentType.MONTHLY:
                numberOfInstalments = 'Monthly';
                break;
            case InstalmentType.BESPOKE:
                numberOfInstalments = 'Bespoke';
                break;
            default:
                numberOfInstalments = 'Unknown';
        }

        const now = moment();
        window.dataLayer.push({
            event: 'purchase',
            ecommerce: {
                transaction_id: now.unix(),
                value: basket.products[0].selected_price.non_discounted,
                tax: 0,
                currency: room.currency,
                coupon: '',
                items: [
                    {
                        item_name: room.development_slug,
                        item_id: `${room.academic_year} ${room.room_code}`,
                        price: basket.products[0].selected_price.non_discounted,
                        item_brand: building.city_slug,
                        category: category.join('/'),
                    },
                ],
            },
            room_type: room.unit_type,
            floor: room.floor,
            view: room.view,
            number_of_students: basket.products[0].selected_students,
            start_date: userChoices.term?.startDate,
            end_date: userChoices.term?.endDate,
            booking_length: userChoices.term?.name,
            year: now.year(),
            university: userState.session.user.user_metadata.university,
            year_of_study: room.academic_year,
            nationality: userState.session.user.user_metadata.nationality,
            pay_instalments: numberOfInstalments,
            building_name: building.building_name,
            country: userState.session.user.user_metadata.country,
            ip_country: basket.tracking.geo?.ip_country ?? '',
            ip_region: basket.tracking.geo?.ip_region ?? '',
            ip_city: basket.tracking.geo?.ip_city ?? '',
        });
    };
};
